import type { Campaign } from '@common/models/campaign-model';

/**
 * FE#252 — build the copy used when duplicating a campaign.
 *
 * The bug: `duplicateCampaignThunk` staged a transient `newCampaign` and NEVER
 * persisted it (no `DBCampaignThunks.create`), then jumped the legacy bulk
 * wizard to the 'finish' tab — so "Duplicate" (calendar 3-dot menu) didn't
 * actually duplicate and never routed to the new copy. This pure builder
 * produces the copy object the thunk now creates + opens.
 *
 * Two guards matter and are the reason this is a named, tested function:
 *  - the copy NEVER carries the original's `_id` — otherwise a create would
 *    patch the original instead of making a new campaign;
 *  - the copy starts from `defaults` (`campaignStatus: 'initial'`), so
 *    duplicating a *running* campaign yields a fresh unlaunched draft, never a
 *    second live/dispatching campaign.
 */
export const buildDuplicateCampaign = (
  original: Campaign,
  defaults: Partial<Campaign>
): Partial<Campaign> => ({
  ...defaults,
  name: `${original.name || 'Campaign'} (Copy)`,
  boardIDArray: original.boardIDArray,
  template: original.template,
  timing: original.timing,
});
